import { map } from 'lodash'

const brandCurationTaskEditorFormInitialValues = values => ({
  mainLocationTypeId: values.brand?.mainLocationType?.id,
  additionalLocationTypeIds: map(values.brand?.additionalLocationTypes, 'id'),
  cuisineTypeId: values.brand?.cuisineType?.id,
})

export default brandCurationTaskEditorFormInitialValues
